import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { portalApi, getPortalToken, setPortalToken } from "@/lib/portalApi";

const PortalContext = createContext(null);

export function PortalProvider({ children }) {
  const [party, setParty] = useState(null);

  useEffect(() => {
    if (!getPortalToken()) return setParty(false);
    portalApi.get("/auth/me").then((r) => setParty(r.data)).catch(() => { setPortalToken(null); setParty(false); });
  }, []);

  const start = useCallback((data) => { setPortalToken(data.access_token); setParty(data.party); return data.party; }, []);
  const login = useCallback(async (mobile, password) => start((await portalApi.post("/auth/login", { mobile, password })).data), [start]);
  const magic = useCallback(async (token) => start((await portalApi.post("/auth/magic", { token })).data), [start]);
  const logout = useCallback(() => { setPortalToken(null); setParty(false); }, []);

  return <PortalContext.Provider value={{ party, login, magic, logout }}>{children}</PortalContext.Provider>;
}

export const usePortal = () => useContext(PortalContext);
